import React from 'react'
import { Icon } from './DocumentCheck.elements'

type Props = {
  className?: string
}

export const CertificateIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 14 14"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M13 5.21429V3C13 2.44772 12.5523 2 12 2H2C1.44772 2 1 2.44772 1 3V10C1 10.5523 1.44772 11 2 11H9" stroke="white"/>
    <line x1="3" y1="4.5" x2="7" y2="4.5" stroke="white" strokeLinejoin="round"/>
    <line x1="3" y1="6.5" x2="6" y2="6.5" stroke="white" strokeLinejoin="round"/>
    <path d="M9 9L9 13L11 11.6968L13 13V9" stroke="white"/>
    <circle cx="11" cy="7" r="2.5" stroke="white"/>
  </Icon>
)